import { SearchResult } from '../types'
import SearchResultItem from './SearchResultItem'

interface SearchResultsProps {
  results: SearchResult[]
}

export default function SearchResults({ results }: SearchResultsProps) {
  if (results.length === 0) {
    return null
  }

  return (
    <div className="space-y-3">
      {results.map((result, index) => (
        <SearchResultItem 
          key={`${result.url}-${index}`}
          result={result}
          rank={index + 1}
        />
      ))}
    </div>
  )
}
